export default __webpack_public_path__ + "static/media/accessModified.18a30831.svg";